"use client";

import { useEffect } from "react";
import { i18n } from "./instance";
import { useLanguage } from "./use-language";

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const { language } = useLanguage();

  useEffect(() => {
    if (i18n.language !== language) {
      void i18n.changeLanguage(language);
    }
  }, [language]);

  return <>{children}</>;
}
